
import $ from "jquery"

import StickyNavbarHandler from "app/sticky_navbar_handler"

interface Inputs {
  selected_listing_id: any
}

function init({selected_listing_id}: Inputs) {
  const $contact_request_box = $(".cell-serviced-apartment-contact-request-box")
  const $listing_id_radio_buttons = $contact_request_box.find("input[name='listing_id']:radio")
  const $listing_entry_selectors = $(".cell-serviced-apartment-contact-request-box__contact-info__selector")
  const $listing_entries = $(".cell-serviced-apartment-contact-request-box__contact-info__listing")

  if ($listing_id_radio_buttons.length === 0 ||
    $listing_entries.length <= 1) {
    return
  }

  // Activate only the selected one
  $listing_id_radio_buttons
  .on("change", (e) => {
    const currentTarget = e.currentTarget as HTMLInputElement

    // Deactivate all items
    // Activate only the selected one
    $listing_entries
    .removeClass("active")
    .filter(`.${currentTarget.value}`)
    .addClass("active")

    // Deactivate all rows
    // Activate only the selected one
    $listing_entry_selectors
    .find("tr")
    .removeClass("active")
    .filter(`.${currentTarget.value}`)
    .addClass("active")
  })
  $listing_entry_selectors
  .find("tr")
  .on("click", (e) => {
    const currentTarget = e.currentTarget as HTMLInputElement

    // Check the newly clicked radio button
    $(currentTarget).find("input[name='listing_id']:radio")
    .prop("checked", true)
    .trigger("change")
  })
  $(".page-section--action-shortcuts__btn-contact")
  .on("click", () =>
    // Scroll to the active contact request box
    StickyNavbarHandler.scrollTo(
      $listing_entry_selectors
    )
  )

  // Preselect the one passed through data attribute
  // Also trigger event listeners registered earlier
  if (selected_listing_id != null) {
    const $valid_option_to_be_selected =
      $listing_id_radio_buttons
      .filter(`[value=${selected_listing_id}]`)

    if ($valid_option_to_be_selected.length === 1) {
      $valid_option_to_be_selected
      .prop("checked", true)
      .trigger("change")
    }
  }
}


export default {
  init,
}


